import Navbar from '../components/Navbar'
import Announcement from '../components/Announcement'
import Footer from '../components/Footer'
import styled from 'styled-components'
import { Add, Remove } from '@mui/icons-material'
import { mobile } from '../responsive'
import { useDispatch,useSelector } from 'react-redux'
import StripeCheckout from "react-stripe-checkout"
import { Link, useNavigate } from 'react-router-dom'
import { useEffect, useState } from "react";
import { userRequest } from "../requestMethods";
import { removeProduct } from '../redux/cartRedux';
import DeleteIcon from '@mui/icons-material/Delete';

const Container = styled.div``

const Wrapper = styled.div`
    padding: 20px;
    ${mobile({ padding: "10px" })}
`

const Title = styled.div`
    font-weight: 300;
    text-align: center;
`

const Top = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
`
const TopButton = styled.button`
    padding: 10px;
    font-weight: 600;
    cursor: pointer;
    border : ${props => props.type === "filled" && "none"};
    background-color : ${props => props.type === "filled" ? "black" : "transparent"};
    color : ${props => props.type === "filled" && "white"};

`

const TopTexts = styled.div`
    ${mobile({ display: "none" })}
`

const TopText = styled.span`
    text-decoration:underline;
    cursor: pointer;
    margin: 0px 10px;
`

const Bottom = styled.div`
    display: flex;
    justify-content: space-between;
    ${mobile({ flexDirection: "column" })}
`

const Info = styled.div`
    flex: 3;
`

const Product = styled.div`
    display: flex;
    justify-content: space-between;
    ${mobile({ flexDirection: "column" })}
`

const ProductDetail = styled.div`
    flex: 2;
    display: flex;
`

const Image = styled.img`
    width: 200px;
  ${mobile({ width: "150px" })}

`

const Details = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  ${mobile({ padding:"0px" })}
`

const ProductName = styled.span``

const ProductId = styled.span``

const ProductColor = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${(props) => props.color};
`;

const ProductSize = styled.span``

const PriceDetail = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    ${mobile({ flexDirection: "row", justifyContent: "space-evenly" })}   //NEWW  by MMMEEEEE
`
const ProductAmountContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const ProductAmount = styled.div`
  font-size: 24px;
  margin: 5px;
  ${mobile({ margin: "5px 15px" })}

  /* border-radius: 10px;
  border: 2px solid teal;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center; */
`;

const ProductPrice = styled.div`
  font-size: 30px;
  font-weight: 200;
  margin-bottom: 20px;
`;

const Hr = styled.hr`
  background-color: #d6d6d6;
  border: none;
  height: 1px;
`;

const Summary = styled.div`
  flex: 1;
  border: 0.5px solid lightgray;
  border-radius: 10px;
  padding: 20px;
  height: 50vh;
`;

const SummaryTitle = styled.h1`
  font-weight: 200;
`;

const SummaryItem = styled.div`
  margin: 30px 0px;
  display: flex;
  justify-content: space-between;
  font-weight: ${(props) => props.type === "total" && "500"};
  font-size: ${(props) => props.type === "total" && "24px"};
`;

const SummaryItemText = styled.span``;

const SummaryItemPrice = styled.span``;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  background-color: black;
  color: white;
  font-weight: 600;
  cursor: pointer;
`;


const Cart = () => {
    const cart = useSelector((state) => state.cart);
    const user = useSelector((state) => state.user.currentUser);

    const [stripeToken, setStripeToken] = useState(null);
    const navigate = useNavigate();

    const onToken = (token) => {
//         console.log(token);
        setStripeToken(token);
    };

    const KEY = process.env.REACT_APP_STRIPE;
    useEffect(() => {
        const makeRequest = async () => {
            try {
                const res = await userRequest.post("/checkout/payment", {
                    tokenId: stripeToken.id,
                    amount: cart.total * 100,
                    card: stripeToken.card,
                });
//                 console.log(res.data);
                console.log(cart);
                navigate("/success", {
                    state: {
                        stripeData: res.data,
                        products: cart,
                    }
                });


                // const confirm = await userRequest.post("/checkout/payment/confirm", {
                //     secret: res.data.id,
                // });
                // console.log(confirm.data)

            } catch { }
        };
        stripeToken && makeRequest();
        // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [stripeToken, cart.total, navigate]);

    const dispatch = useDispatch();
    const handleClick = (id, amount) => {
        dispatch(
            removeProduct({ id, amount })
        );
    }
    return (
        <Container>
            <Navbar />
            <Announcement />
            <Wrapper>
                <Title></Title>
                <Top>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                        <TopButton>CONTINUE SHOPPING</TopButton> </Link>
                    <TopTexts>
                        <TopText>Shopping Bag(2)</TopText>
                        <TopText>Your Wishlist (0)</TopText>
                    </TopTexts>
                    <TopButton type='filled'>CHECKOUT NOW</TopButton>
                </Top>
                <Bottom>
                    <Info>
                        {cart.products.map((product) => (
                            <Product>
                                <ProductDetail>
                                    <Image src={product.img} />
                                    <Details>
                                        <ProductName><b>Product:</b> {product.title}</ProductName>
                                        <ProductId><b>ID:</b> {product._id}</ProductId>
                                        <ProductColor color={product.color} />
                                        <ProductSize><b>Size:</b> {product.size}</ProductSize>
                                    </Details>
                                </ProductDetail>
                                <PriceDetail>
                                    <ProductAmountContainer>
                                        <Add />
                                        <ProductAmount>{product.quantity}</ProductAmount>
                                        <Remove />
                                    </ProductAmountContainer>
                                    <ProductPrice>₹ {product.price * product.quantity}</ProductPrice>
                                    <DeleteIcon sx={{ color: "black", fontSize: 30, cursor: "pointer", marginBottom: "20px" }} onClick={() => { handleClick(product._id, product.price * product.quantity) }} />
                                </PriceDetail>
                            </Product>
                        ))}
                        < Hr />
                    </Info>
                    <Summary>
                        <SummaryTitle>ORDER SUMMARY</SummaryTitle>
                        <SummaryItem>
                            <SummaryItemText>Subtotal</SummaryItemText>
                            <SummaryItemPrice>₹ {cart.total}</SummaryItemPrice>
                        </SummaryItem>
                        <SummaryItem>
                            <SummaryItemText>Estimated Shipping</SummaryItemText>
                            <SummaryItemPrice>₹ {cart.total === 0 ? 0 : cart.total < 2000 ? 100 : cart.total * 0.05}</SummaryItemPrice>
                        </SummaryItem>
                        <SummaryItem>
                            <SummaryItemText>Shipping Discount</SummaryItemText>
                            <SummaryItemPrice>₹ {cart.total === 0 ? 0 : cart.total < 2000 ? -100 : -cart.total * 0.05}</SummaryItemPrice>
                        </SummaryItem>
                        <SummaryItem type="total">
                            <SummaryItemText>Total</SummaryItemText>
                            <SummaryItemPrice>₹ {cart.total}</SummaryItemPrice>
                        </SummaryItem>
                        {
                            cart.total === 0 ?
                                <Link to="/">
                                    <Button>LET'S DO SHOPPING FIRST</Button>
                                </Link>
                                :
                                user ?
                                    <StripeCheckout
                                        name="Poorvank Shop"
                                        image="https://avatars.githubusercontent.com/u/1486366?v=4"
                                        billingAddress
                                        shippingAddress
                                        description={`Your total is ₹${cart.total}`}
                                        amount={cart.total * 100}
                                        token={onToken}
                                        stripeKey={KEY}
                                        currency="INR"
                                    >
                                        <Button>CHECKOUT NOW</Button>
                                    </StripeCheckout>
                                    :

                                    <Link to="/login">
                                        <Button>LET'S LOGIN FIRST</Button>
                                    </Link>

                        }
                    </Summary>
                </Bottom>
            </Wrapper>
            <Footer />
        </Container>
    )
}

export default Cart
